import B2BProductPurchaseOptions from './b2b-product-purchase-options.component'

export default B2BProductPurchaseOptions
